module.exports = __webpack_public_path__ + "static/img/NL.ac70f70c.svg";